// extracted by mini-css-extract-plugin
export default {"form":"styles_form__Nh6xe","input":"styles_input__ErtON"};